import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Select, Store } from '@ngxs/store';
import { ConfirmationBoxComponent } from 'src/app/shared/components/confirmation-box/confirmation-box.component';
import { DeleteService, GetNewServiceList } from '../../state/service-action';
import { NewServicesState } from '../../state/ayen-service.state';
import { Observable, ReplaySubject, Subscription } from 'rxjs';
import { handlePaginationChangeUtil } from 'src/app/core/services/uitls/navigation.utils';
import { FiltersService } from 'src/app/core/services/filters/filters.service';
import { FilterUtilService } from 'src/app/core/services/uitls/filter-utilizer/filter-util.service';
import { UserType } from 'src/app/models/enums/user-type.enum';
import { UserService } from 'src/app/core/services/user/user.service';

@Component({
  selector: 'app-services-list',
  templateUrl: './services-list.component.html',
  styleUrls: ['./services-list.component.scss'],
})
export class ServicesListComponent implements OnInit {
  disabledDelete: boolean = true;
  config: any;
  page: number = 1;
  page_size: number = 20;
  totalRecords: any = 0;
  services: any;
  searchValue: any;
  showSpinner: boolean = true;
  deleteDialogRef: MatDialogRef<ConfirmationBoxComponent>;
  @Select(NewServicesState.getNewServicesList) serviceList$: Observable<any>;
  payload: { page: number; page_size: number; is_exsep?: boolean } = {
    page: this.page,
    page_size: this.page_size,
  };
  currentItemsPerPage: number;
  @ViewChild('goUp', { static: true }) contentPage: ElementRef;
  filterPage: string = 'DYNAMIC_SERVICES';
  savedFilters: any = [];
  filterDataInit = {};
  filterParamsUrl = {};
  spinnerKey: string = 'spinner';
  spinner: boolean = true;
  filterData: any;
  orderingState: boolean = false;
  is_sopra: boolean = false;
  destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  pageTitle: string = '';
  params: any;
  servicesSub: Subscription;
  currentUserType: number;
  userType = UserType;

  constructor(
    private router: Router,
    private dialog: MatDialog,
    private store: Store,
    private filter: FiltersService,
    private filterUtil: FilterUtilService,
    private route: ActivatedRoute,
    private userService: UserService,
  ) {
    this.config = {
      id: 'dynamicServicePagination',
      itemsPerPage: this.page_size,
      currentPage: this.page,
      totalItems: this.totalRecords,
    };
  }

  ngOnInit(): void {
    this.is_sopra = this.route.snapshot.params.sopra == 'sopra';
    this.filterPage = this.is_sopra ? 'EXSEP_DYNAMIC_SERVICES' : 'DYNAMIC_SERVICES'
    this.pageTitle = this.is_sopra ? 'خدمات سوبرا' : 'الخدمات';
    this.currentUserType = this.userService.userType;
    this.route.queryParams.subscribe((params) => {
      if (params.page && params.page_size) {
        this.page = Number(params.page)
        this.page_size = Number(params.page_size)
        this.config.currentPage = Number(params.page)
        this.config.itemsPerPage = Number(params.page_size)
      } else {
        this.router.navigate([], {
          queryParams: { page: 1, page_size: 20 },
          queryParamsHandling: 'merge',
        });
      }
      if (Object.keys(params).length > 0) {
        this.searchValue = params['query'] ?? '';
        const { query, ...restParams } = params;
        this.filterParamsUrl = restParams;
        this.filterDataInit = restParams;
      }
    });
    this.servicesSub = this.serviceList$.subscribe((data) => {
      if (data && data['results']) {
        this.showSpinner = false;
        this.services = data.results;
        this.config['totalItems'] = data.count;
        this.currentItemsPerPage = data.results.length;
        const queryParams= { page: 1, page_size: 20 };
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: {...queryParams, ...this.filterParamsUrl, ...(this.searchValue ? { query: this.searchValue } : {})},
          queryParamsHandling: '',
          replaceUrl: true,
        });
      }
    });
    this.getDynamicServices();
    this.getFilterData();
    this.filterUtil.getSavedFilters(this, this.filterPage);
    this.filter.changeSelectedFilter(this.filterDataInit);
    this.filterUtil.applySelectedFilter(this, this.getDynamicServices, this.spinnerKey);
  }
  
   getFilterData() {
    let params = {
      filter_page: this.filterPage,
    };
    this.filter.getFiltersData(params).subscribe(
      (data) => {
        this.filterData = data;
      },
      (error) => {
        console.error('Error fetching filter data:', error);}
    );
  }
  
   filterFormValues(event) {
    this.spinner = true;
    this.filterParamsUrl = event.filterParamsUrl;
    this.spinner = true;
    this.config.currentPage = 1;
    this.config.itemsPerPage = 20;
    this.getDynamicServices();
  }

  getDynamicServices( ordering?: string  ) {
    this.params = {
      page: this.config.currentPage,
      page_size: this.config.itemsPerPage,
      is_exsep: this.is_sopra,
      ...this.filterParamsUrl,
    };
    this.showSpinner = true;
    if (this.searchValue) {
      this.params['query'] = this.searchValue;
    }
    if (ordering) {
      this.params['ordering'] = ordering;

    }
    this.store.dispatch(new GetNewServiceList(this.params));
  }

  showDeleteConfirmationBox(id, index, name) {
    this.deleteDialogRef = this.dialog.open(ConfirmationBoxComponent, {
      data: {
        id: id,
        index: index,
        message: `هل أنت متأكد من حذف خدمة "${name}"؟`,
      },
    });
    this.deleteDialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.deleteService(result);
      }
    });
  }
  
  changeOrderingStatus() {
    this.orderingState = !this.orderingState;
    if (this.orderingState) {
      this.filterParamsUrl = { ...this.filterParamsUrl, ordering: '-id' };
      this.getDynamicServices('-id');
    } else {
      this.filterParamsUrl = { ...this.filterParamsUrl, ordering: 'id' };
      this.getDynamicServices('id');
    }
  }
  deleteService(event) {
    this.store.dispatch(new DeleteService(event.id));
  }

  pageChanged(event) {
    handlePaginationChangeUtil(
      this.contentPage,
      (value: boolean) => this.showSpinner = value,
      this.router,
      'page',
      event
    );
    this.config.currentPage = event;
    this.payload = {
      ...(this.searchValue ? { query: this.searchValue } : {}),
      page: event,
      is_exsep: this.is_sopra,         
      page_size: this.payload.page_size ?? 20 ,
      ...this.filterParamsUrl
    };
    this.payload['page'] = event;
    this.payload['is_exsep'] = this.is_sopra;
    this.store.dispatch(new GetNewServiceList(this.payload));
  }
  pageSizeChanged(event) {
    handlePaginationChangeUtil(
      this.contentPage,
      (value: boolean) => this.showSpinner = value,
      this.router,
      'page_size',
      event
    );
    this.config.itemsPerPage = event;
    this.payload['page'] = this.config.currentPage;
    this.payload['page_size'] = event;
    this.payload['is_exsep'] = this.is_sopra;
    this.store.dispatch(new GetNewServiceList(this.payload));
  }

  quickSearch(event) {
    this.showSpinner = true;
    this.searchValue = event;
    this.config.currentPage = 1;
    this.config.itemsPerPage = 20;
    this.payload = {
      ...(this.searchValue ? { query: this.searchValue } : {}),
      page: this.config.currentPage,
      page_size: this.config.itemsPerPage,
      is_exsep: this.is_sopra,
      ...this.filterParamsUrl
    };
    this.store.dispatch(new GetNewServiceList(this.payload));
  }

  goServiceDetails(id) {
    this.router.navigate([`pages/services/edit/${id}`]);
  }

  goServiceSettings(id) {
    this.router.navigate([`pages/services/settings/${id}`]);
  }

  goWebsiteConfigration(id) {
    this.router.navigate([`pages/services/website-configuration/${id}`]);
  }

  goSEOConfigration(id) {
    this.router.navigate([`pages/services/seo-configuration/${id}`]);
  }
  
  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
    this.filter.changeSelectedFilter({});
    this.servicesSub.unsubscribe();
  }
}
